/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * Breadcrumb-item CSS
 */
export const styles = css`
  :host {
    display: flex;
    align-items: center;
    text-align: center;
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-size: var(--nile-font-size-small, var(--ng-font-size-text-sm));
    font-style: normal;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-semibold));
    line-height: var(--nile-line-height-xsmall, var(--ng-line-height-text-sm));
    letter-spacing: 0.2px; 
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .nile-breadcrumb-item__arrow {
    margin: 0 var(--nile-spacing-md, var(--ng-spacing-md));
  }

  .nile-breadcrumb-item__arrow-hidden {
    display: none;
  }

  .nile-breadcrumb-item__slot-text {
    color: var(--nile-colors-dark-500, var(--ng-colors-text-quaternary-500));
  }

  .nile-breadcrumb-item__slot-text:hover {
    color: var(--nile-colors-primary-600, var(--ng-colors-text-tertiary-hover));
    cursor: pointer;
  }

  .nile-breadcrumb-item__last-slot-text {
    color: var(--nile-breadcrumb-color, var(--ng-colors-text-brand-secondary-700));
  }
`;

export default [styles];
